<template>
  <div class="detail__wrap" v-show="visible">
    <el-breadcrumb separator-class="el-icon-arrow-right" class="crumbs__wrap">
      <el-breadcrumb-item
        ><span @click="toggle(false)" style="font-weight: bold; cursor: pointer"
          >企业管理</span
        ></el-breadcrumb-item
      >
      <el-breadcrumb-item>{{
        reportType == 1 ? "企业审核" : "详情"
      }}</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="section shadow">
      <div class="back-box">
        <el-button
          class="backBtn"
          plain
          icon="el-icon-d-arrow-left"
          @click="toggle(false)"
          size="mini"
          >返回</el-button
        >
        <el-button size="mini" type="primary" @click="viewLog">变更记录{{submit_total}}次</el-button>
      </div>
      <div class="main">
        <el-form
          class="staff-from"
          v-loading="loading"
          element-loading-text="加载中…"
          ref="elFormDom"
          label-width="110px"
          label-position="top"
          :model="form.data"
          size="mini"
        >
          <!-- 工商信息 -->
          <div style="display: flex;
          justify-content: space-between;">
            <div class="section-title">工商信息</div>
            <template v-if="reportType == 1">
              <div style="color: #999;" v-if="!info.pass_at && info.reject_at">认证失败用户</div>
              <div style="color: #999;" v-else-if="!info.pass_at">新用户</div>
              <div style="color: #999;" v-else-if="info.submit_use == 3">修改工商信息</div>
            </template>
          </div>
          <el-divider></el-divider>
          <el-row>
            <el-col :span="4">
              <el-form-item label="营业执照">
                <el-image
                  style="width: 110px; height: 110px"
                  :src="form.data.business"
                  fit="cover"
                  :preview-src-list="[form.data.business]"
                ></el-image>
              </el-form-item>
            </el-col>
            <el-col :span="20">
              <el-row :gutter="10">
                <el-col :span="8">
                  <el-form-item label="公司名称">
                    <el-input
                      v-model="form.data.name"
                      :readonly="true"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="统一社会信用代码">
                    <el-input
                      v-model="form.data.xy_code"
                      :readonly="true"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col :span="8">
                  <el-form-item label="注册资本（万元）">
                    <el-input
                      v-model="form.data.register_money"
                      :readonly="true"
                    >
                      <template #suffix>万元</template>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="成立日期">
                    <el-input
                      v-model="form.data.register_date"
                      :readonly="true"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col :span="8">
                  <el-form-item label="法定代表人">
                    <el-input
                      v-model="form.data.legal_name"
                      :readonly="true"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="身份证号">
                    <el-input
                      v-model="form.data.legal_id_card"
                      :readonly="true"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col :span="8">
                  <el-form-item label="公司类型">
                    <el-input
                      v-model="form.data.nature"
                      :readonly="true"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="融资情况">
                    <el-input
                      v-model="form.data.financing_type_str"
                      :readonly="true"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
          </el-row>

          <!-- 详细信息 -->
          <div class="section-title">详细信息</div>
          <el-row>
            <el-col :span="4">
              <el-form-item label="企业logo">
                <el-image
                  style="width: 110px; height: 110px"
                  :src="form.data.avatar"
                  fit="cover"
                  :preview-src-list="[form.data.avatar]"
                ></el-image>
              </el-form-item>
            </el-col>
            <el-col :span="20">
              <el-row :gutter="10">
                <el-col :span="8">
                  <el-form-item label="行业类型">
                    <el-input
                      v-model="form.data.industry_name"
                      :readonly="true"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="公司规模">
                    <el-input
                      v-model="form.data.scale"
                      :readonly="true"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col :span="8">
                  <el-form-item label="所在地区">
                    <el-input
                      v-model="form.data.area_str"
                      :readonly="true"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="工作地点">
                    <el-input
                      v-model="form.data.working_address"
                      :readonly="true"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col :span="24">
                  <el-form-item label="公司简介">
                    <el-input
                      readonly
                      type="textarea"
                      :autosize="{ minRows: 3, maxRows: 10 }"
                      v-model="form.data.introduce"
                    >
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
          </el-row>

          <!-- 公司环境 -->
          <el-row :gutter="10">
            <el-col :span="24">
              <el-form-item label="公司环境">
                <el-image
                  v-for="item in form.data.image"
                  :key="item"
                  style="
                    width: 160px;
                    height: 110px;
                    margin-right: 5px;
                    border: solid 1px #eee;
                  "
                  :src="item"
                  fit="cover"
                  :preview-src-list="form.data.image"
                ></el-image>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 管理员信息 -->
          <div class="section-title">管理员信息</div>
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item label="联系人">
                <el-input v-model="form.data.legal" :readonly="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="身份证号">
                <el-input v-model="form.data.id_card" :readonly="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="联系电话">
                <el-input v-model="form.data.phone" :readonly="true"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="10" v-if="!!form.data.reject_reson">
            <el-col :span="24">
              <el-form-item label="上次拒绝理由">
                <el-input
                  v-model="form.data.reject_reson"
                  :readonly="true"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
    <!-- 待审核时展示 -->
    <div class="footer-btn" v-if="this.reportType == 1">
      <el-row type="flex" justify="center" class="btn__wrap">
        <el-button type="primary" :loading="form.loading" @click="handleAccept"
          >通过</el-button
        >
        <el-button @click="handleReject">拒绝</el-button>
      </el-row>
    </div>
    <editLogDialog ref="editLogDialogRef"></editLogDialog>
  </div>
</template>
<script>
import editLogDialog from './editLogDialog.vue';
export default {
  name: "ReportDetail",
  components:{
    editLogDialog
  },
  data() {
    return {
      info:{},
      visible: false,
      loading: false,
      reportType: 1, // 1:待审核 2:已激活 3:未充值 4:审核失败 5:下架企业 6:待完善
      submit_total:0,
      form: {
        data: {
          image: [],
        },
      },
    };
  },
  created() {
    this.getDetail();
  },
  methods: {
    viewLog() {
      let dom = this.$refs.editLogDialogRef;
      dom.toggle(true);
      dom.getDetail(this.info);
    },
    getDetail(row) {
      if (!!row) {
        this.reportType = row.type;
        let _params = {};
        if (row.type == 1 || row.type == 4) {
          _params = {
            id: row.id,
            is_check: 1, //(待审核时加条件)是否审核页面：0-否；1-是；
          };
        } else {
          _params = {
            id: row.id,
          };
        }
        this.$http
          .get("/admin/company/info", { params: _params })
          .then((res) => {
            this.info = res.data;
            this.submit_total = res.data.submit_total;
            this.form.data = res.data;
            this.form.data.area_str =
              res.data.province + res.data.city + res.data.area;
          });
      }
    },
    // 通过
    handleAccept() {
      this.$confirm("请确认是否通过审核？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let _params = {
            id: this.form.data.id,
            type: 1, // 类型 1:通过 2:拒绝
          };
          this.$http.post("/admin/company/check", _params).then((res) => {
            if (res.code === 1) {
              this.$message.success("操作成功！");
              this.toggle(false);
              this.$emit("refresh", 2);
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {});
    },
    // 拒绝
    handleReject() {
      this.$prompt("请输入拒绝理由", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(({ value }) => {
          if (!value) {
            return this.$message.warning("请输入拒绝理由！");
          }
          let _params = {
            id: this.form.data.id,
            type: 2, // 类型 1:通过 2:拒绝
            reject_reson: value,
          };
          this.$http.post("/admin/company/check", _params).then((res) => {
            if (res.code === 1) {
              this.$message.success("操作成功！");
              this.toggle(false);
              this.$emit("refresh");
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {});
    },
    reset(done) {
      done && done();
    },
    toggle(show) {
      this.visible = show;
      !show && this.reset();
    },
  },
};
</script>
<style scoped lang="scss">
.detail__wrap {
  @include position($t: 0, $r: 0, $b: 0, $l: 0);
  background-color: #f5f5f5;
  padding: 20px;
  padding-bottom: 100px;
  z-index: 9;
  overflow-y: scroll;

  .crumbs__wrap {
    margin-bottom: 20px;
  }

  .main {
    width: 100%;
    box-sizing: border-box;
    background-color: #fff;
    padding: 20px;

    .section-title {
      font-size: 16px;
      font-weight: bold;
      color: #262626;
      margin: 24px 0 16px;
      padding-left: 10px;
      border-left: 4px solid #0c64c6;

      &:first-child {
        margin-top: 0;
      }
    }
  }
  .back-box{
    background-color: #fff;
    padding: 20px;
    display: flex;
    justify-content: space-between;
  }
}
.footer-btn {
  position: fixed;
  left: 200px;
  right: 0;
  bottom: 0;
  background: #fff;
  padding: 15px 20px;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  z-index: 100;
  box-sizing: border-box;
  .btn__wrap {
    margin: 0;
  }
}
</style>